<script setup>
const props = defineProps({
  requestEmail: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const { t } = useI18n()

const WHITESPACE_RE = /\s/g

function handleRequest() {
  const recipient = props.requestEmail.recipient
  const subject = encodeURIComponent(props.requestEmail.subject)
  const body = encodeURIComponent(props.requestEmail.template)

  const mailto = `mailto:
        ${recipient}
        ?subject=${subject}
        &body=${body}
    `.replace(WHITESPACE_RE, '')

  window.location.href = mailto
}

const anchorTitle = computed(() => {
  return useAnchorTitle(t('course.groupRequest.title'))
})
</script>

<template>
  <h2
    :id="anchorTitle"
    class="scale-3 scale-3--bold-uppercase spacer-25-20"
  >
    {{ t('course.groupRequest.title') }}
  </h2>
  <div class="equal-base spacer-30">
    {{ t('course.groupRequest.text') }}
  </div>
  <FormButton
    :label="t('course.groupRequest.request')"
    :disabled="disabled"
    @click="handleRequest()"
  />
</template>

<style lang="scss" scoped></style>
